import React from "react";
import { View, StyleSheet, Platform } from "react-native";
import { findIndex } from "lodash";

import { HomeCardGroups } from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";
import ReflectionPieChart from "../../home/cards/ReflectionPieChart";

export default function EditReflectionBubbleChart({
  reflection,
  saveNotes = () => {},
}) {
  const data = reflection.core_elements;
  if (!data) return null;

  // ------------------------------------- METHODS -------------------------------------
  const savePieChartNotes = (mood, note) => {
    saveNotes({
      edit_gem_mood: mood,
      edit_notes: note,
      isNew: !reflection.edit_notes && !reflection.edit_gem_mood,
    });
  };

  const getCoreElementValueByDate = (d, coreElement) => {
    const timelineData = d[coreElement] || {};
    const { hours, days } = timelineData;

    let total = 0;
    let progress = 0;

    if (hours && days) {
      const dayIndex = findIndex(days, (day) => day === reflection.edit_day);
      total = hours[dayIndex] ? hours[dayIndex] : 0;
      const prev = hours[dayIndex - 1] ? hours[dayIndex - 1] : 0;
      progress = total && prev ? ((total - prev) * 100) / prev : 0;
    }

    return {
      total,
      progress,
    };
  };

  let pieData = {
    gem_text: reflection.edit_notes,
    gem_mood: reflection.edit_gem_mood,
  };
  Object.keys(HomeCardGroups).forEach((g) => {
    const key = g.toLowerCase();
    const { total, progress } = getCoreElementValueByDate(data, key);
    pieData[`${key}_total`] = total;
    pieData[`${key}_pct`] = Math.floor(progress);
  });

  return (
    <View style={styles.container}>
      <ReflectionPieChart
        data={pieData}
        saveCardData={savePieChartNotes}
        showIntervalText={false}
        moodText={`How was the ${reflection?.edit_time_unit}?`}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
    zIndex: 11,
    marginBottom: 8,
  },
  statcards: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    paddingHorizontal: 15,
    marginTop: 0,
  },
  statcard: {
    width: 64,
    height: 70,
    backgroundColor: "#F4F6FA",
    borderRadius: 4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginHorizontal: 3,
  },
  numbers: {
    flexDirection: "row",
  },
  statcardHours: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
  },
  statcardMinutes: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 9,
    lineHeight: 12,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
});
